const _ = require('lodash');
const loyaltyPointsCalculator = require('../../../common/loyalty/loyalty-points-calculator');
const getCategories = require('../../../olycommon/analytics/dtm/helpers/product-categories.js');

function formatDisplayDate(dateObject) {
    return dateObject ? `${_.padStart(dateObject.getDate(), 2, 0)}/${_.padStart(dateObject.getMonth() + 1, 2, 0)}/${dateObject.getFullYear()}` : '';
}

function buildDeliveryTime(order) {
    return `${formatDisplayDate(new Date(order.DeliveryDate))} between ${order.DeliveryStartTime} and ${order.DeliveryEndTime}`;
}

function sumTransactionTotal(paymentBreakdown) {
    return paymentBreakdown.Account
            + paymentBreakdown.CreditCard
            + paymentBreakdown.PayPal
            + paymentBreakdown.GiftCard
            + paymentBreakdown.WowRewards
            + paymentBreakdown.Coupon
            + paymentBreakdown.eVoucher;
}

/**
 * Adobe Digital Data Transaction node DataLayer.
 */
module.exports = function (data) {
    return {
        transaction: {
            transactionID: data.orderDetails.OrderId,
            profile: {
                status: data.orderDetails.ShopperStatusId,
                shippingAddress: {
                    deliveryTime: buildDeliveryTime(data.orderDetails),
                },
            },
            total: {
                basePrice: _.reduce(data.orderDetails.Products, (result, curProduct) => result + curProduct.Subtotal, 0),
                promoCode: data.orderDetails.CouponIDs.join('|'),
                woolworthsRewards: data.orderDetails.RewardsCardNumber,
                voucherDiscount: data.orderDetails.StoreCreditTotal,
                currency: 'AUD',
                taxRate: data.orderDetails.TaxRate,
                staffDiscount: data.orderDetails.TeamDiscount,
                shipping: data.orderDetails.DeliveryFee,
                shippingMethod: data.orderDetails.DeliveryMethod,
                priceWithTax: data.orderDetails.TotalIncludingGst,
                transactionTotal: sumTransactionTotal(data.orderDetails.PaymentBreakdown),
                transactionTotalSplitCC: data.orderDetails.PaymentBreakdown.CreditCard,
                transactionTotalSplitPayPal: data.orderDetails.PaymentBreakdown.PayPal,
                transactionTotalSplitGC: data.orderDetails.PaymentBreakdown.GiftCard,
                transactionTotalSplitRewards: data.orderDetails.PaymentBreakdown.WowRewards,
                transactionTotalSplitPromoCodes: data.orderDetails.PaymentBreakdown.Coupon,
                transactionTotalSplitEVoucher: data.orderDetails.PaymentBreakdown.eVoucher,
                transactionTotalSplitOnAccount: data.orderDetails.PaymentBreakdown.Account,
                totalPointsEarned: loyaltyPointsCalculator(data.orderDetails.TotalDeferredPoints, data.rewardsPointsConversionBase, false),
                paymentType: _.reduce(data.orderDetails.PaymentBreakdown, (result, current, key) => {
                    // Append paymentType only when the payment type is used in the order.
                    if (current === 0) return result;

                    if (result === '') {
                        return `${key}`;
                    }
                    return `${result}|${key}`;
                }, ''),
            },
            item: _.map(data.orderDetails.Products, product => ({
                product: {
                    productInfo: {
                        productID: product.Stockcode,
                        productName: product.Name,
                        price: product.SalePrice,
                        variant: product.Unit,
                    },
                    category: {
                        primaryCategory: getCategories(product.Source).primaryCategory,
                        subCategory: getCategories(product.Source).subCategory,
                        productBrand: product.Brand,
                        sapDepartment: product.SapCategories ? product.SapCategories.SapDepartmentName : '',
                        sapCategory: product.SapCategories ? product.SapCategories.SapCategoryName : '',
                        sapSubCategory: product.SapCategories ? product.SapCategories.SapSubCategoryName : '',
                        sapSegment: product.SapCategories ? product.SapCategories.SapSegmentName : '',
                    },
                    quantity: product.Quantity,
                    price: product.Subtotal,
                    attributes: {
                        promotionType: product.IsBundle ? 'Bundle' : '',
                    },
                },
            })),
        },
    };
};



// WEBPACK FOOTER //
// ./src/order/confirmation/analytics/order-analytics-mapper-dtm.js